/**
 * Refuses a second finding action while the first is in flight. The mutation hooks call `start()`
 * before `mutate` and `settle()` in `onSettled`, so a click that lands before React re-renders
 * the buttons disabled sends nothing.
 */
export type SingleFlight = { start: () => boolean; settle: () => void };

export const createSingleFlight = (): SingleFlight => {
  const state = { inFlight: false };
  return {
    start: () => {
      if (state.inFlight) return false;
      state.inFlight = true;
      return true;
    },
    settle: () => {
      state.inFlight = false;
    },
  };
};
